<template>
  <div id="customer-list-wrapper">

    <v-layout class="blue-grey lighten-5" id="customer-sort-box" wrap row >

      <v-flex xs2 sm1 >
        <v-checkbox
          @click.naive="toggleAll"
          v-model="this.locations.length > 0 && this.selectedLocations.length===this.locations.length"
          hide-details
          class="ml-4 mt-3"
          :indeterminate="checkboxIndeterminate"
        >

        </v-checkbox>
      </v-flex>

      <v-flex xs5 sm4 class="pa-2 search">
        <v-text-field
        append-icon="search"
        single-line
        hide-details
        v-model="listSearch"
      ></v-text-field>
      </v-flex>

      <v-flex xs5 sm7>
        <span v-if="userRole===viewerRoleName" class="caption hidden-xs-only orange--text">{{$t('account.function-limit')}}</span>
        <customer-add-btn
        ref="customerDialog"
        @child-action="showMessage"
        v-if="userRole!==viewerRoleName"
        />
      </v-flex>
    </v-layout>


    <!-- メイン -->
    <v-container fill-height class="pa-0">
    <v-layout id="customer-list-main" wrap row >

      <!-- 左半分 -->
      <v-flex xs12 sm5 class="white" id="customer-list">
        <!-- search相当はfilteredLocationsで行う。toggleAllとの互換性を確保するためにsearch attributeはつけない。 -->
        <v-data-table
          v-model="selectedLocations"
          :headers="listHeaders"
          :items="filteredLocations"
          class=""
          select-all
          disable-initial-sort
          hide-headers
          :pagination.sync="pagination"
          item-key="locationId"
        >

          <!-- 顧客リストコンテンツ -->
          <template slot="items" slot-scope="props">
            <tr :active="props.selected" @click="props.selected = !props.selected">
              <td>
                <v-checkbox
                  primary
                  hide-details
                  :input-value="props.selected"
                ></v-checkbox>
              </td>
              <td class="text-xs-left body-1">{{ props.item.locationName}}</td>
              <td class="text-xs-right caption grey--text text--darken-2">
                  {{ props.item.organizationName}}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>

      <!-- 右半分 -->
      <v-flex xs12 sm7 id="customer-detail" class="grey lighten-3" >

        <v-tabs
          fixed-tabs
          hide-slider
          class="white mt-3"
          v-if="(selectedLocations.length>0||initDisplayLocations.length>0)"
          >
          <v-tab  class="white" href="#customer-info">
            {{$t('customer.info')}}
          </v-tab>

          <!--  基本情報  -->
          <v-tab-item id="customer-info" class="white">
            <v-card v-for="location in initOrSelectedLocations" class="ma-2 pl-3" :key="location.locationId">
              <v-card-title class="align-baseline pa-0">
                <h2 >{{location.locationName}} &nbsp;&nbsp;&nbsp;</h2>
                <span class="caption"> {{location.organizationName}}</span>
                <v-spacer></v-spacer>

            <div v-if="userRole!==rootRoleName && userRole!==viewerRoleName">
                <v-menu  left offset-y>
                  <v-btn small flat icon slot="activator">
                    <v-icon class="caption grey--text">settings</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile @click="editCustomer(location)">
                      {{$t('btn.edit')}}
                    </v-list-tile>
                    <v-list-tile @click="deleteTarget=location;showDeleteDialog=true">
                      {{$t('btn.delete')}}
                    </v-list-tile>
                  </v-list>
                </v-menu>
            </div>

              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <p>
                  {{$t('customer.active-device')}}:
                  {{location.activeDevices}}
                </p>
                <v-layout>
                  <v-flex xs12 md4 class="cutomer-info pl-2">
                    <h4>{{$t('account.address')}}</h4>
                    {{location.locationAddress}}
                  </v-flex>
                  <v-flex xs12 md4 class="cutomer-info pl-2">
                    <h4>{{$t('account.contact')}}</h4>
                    <div>
                      <v-icon class="body-1">local_phone</v-icon>
                      {{location.locationPhone}}
                    </div>
                    <div>
                      <v-icon class="body-1">mail_outline</v-icon>
                      {{location.locationEmail}}
                    </div>
                  </v-flex>
                  <v-flex xs12 md4 class="cutomer-info pl-2">
                    <h4>{{$t('customer.others')}}</h4>
                    {{$t('customer.geo-location')}}:&nbsp;
                    <span v-if="location.latitude">
                      {{$t('customer.defined')}}
                    </span>
                    <span v-else>
                      {{$t('customer.undefined')}}
                    </span>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>


      </v-flex>

    </v-layout>
  </v-container>
    <!-- 削除 ダイアログ -->
    <v-dialog v-model="showDeleteDialog" scrollable  max-width="300px">
      <v-card >
        <v-card-title>
          {{$t('account.caution-title')}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          {{$t('account.caution-location-remove-text')}}<br/><br/>
          {{deleteTarget.locationName}}
          ({{deleteTarget.organizationName}})<br/>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.prevent="deleteCustomer" color="red">
            {{$t('account.delete')}}
          </v-btn>
          <v-btn small @click.native="showDeleteDialog = false">
            {{$t('account.cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- メッセージ スナックバー -->
    <v-snackbar
      v-model="showSnackbar"
      relative top right
      :color="snackbarColor"
      :timeout="snackbarTimeout"
    >
    {{snackbarMessage}}
    </v-snackbar>

  </div>
</template>

<script>
import config from '@/config.js'
import http from '@/utils/http.js'
import CustomerAddBtn from '@/components/CustomerEdit.vue'

export default {
  components: {
    CustomerAddBtn
  },
  data () {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: config.role.Root,
      viewerRoleName: config.role.Viewer,
      locations: [],

      // リストテーブル用
      pagination: {
        rowsPerPage: 25
      },
      selectedLocations: [],
      listSearch: '',
      listHeaders: [
        {
          text: 'Customer Name',
          align: 'left',
          value: 'locationName'
        },
        {
          text: 'Organization',
          value: 'organizationName'
        }
      ],

      // snackbar
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackbarTimeout: 4000,

      // ダイアログ表示用
      showDeleteDialog: false,
      deleteTarget: {},
      showFormDialog: false,

      // デザインからの要請で最初だけデータ表示
      initDisplayLocations: []

    }
  },
  methods: {
    init () {
      this.getLocations()
    },
    getLocations () {
      http.request('get', '/service2/dashboard/api/Organizations/locationList')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get location list failed. (' + data.result + ')')
            return
          }
          this.locations = data.locations
          this.initDisplayLocations = data.locations
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    editCustomer (location) {
      this.$refs.customerDialog.startDialog(location)
    },
    deleteCustomer () {
      console.log('delete:' + this.deleteTarget.locationId)
      http.request('post', '/service2/dashboard/api/Locations/deregister', {locationId: this.deleteTarget.locationId})
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('delete location failed. (' + data.result + ')')
            let message = ''
            switch (data.result) {
              case -6:
                message = this.$t('customer.error-delete-connecting-device')
                break
              default:
                message = this.$t('customer.error-delete') + '(' + data.result + ')'
                break
            }
            this.showMessage('error', message)
            this.showDeleteDialog = false
            return
          }
          this.showMessage('success', this.$t('customer.success-delete'))
          this.showDeleteDialog = false
          this.getLocations()
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
          this.showMessage('error', error)
          this.showDeleteDialog = false
        })
    },
    showMessage (result, msg) {
      switch (result) {
        case 'error':
          this.snackbarMessage = msg
          this.snackbarColor = 'red lighten-3'
          this.snackbarTimeout = 6000
          this.showSnackbar = true
          break
        case 'success':
          this.getLocations()
          this.selectedLocations = [] // TODO: 一旦消さないと顧客詳細がEDIT時に更新されない
          this.snackbarMessage = msg
          this.snackbarColor = 'teal lighten-2'
          this.snackbarTimeout = 3000
          this.showSnackbar = true
          break
        default:
          return
      }
    },
    toggleAll () {
      // 表示してた初期データを削除
      this.initDisplayLocations = []

      if (this.selectedLocations.length) {
        this.selectedLocations = []
      } else {
        this.selectedLocations = this.filteredLocations
      }
    }
  },
  computed: {
    initOrSelectedLocations () {
      if (this.initDisplayLocations.length > 0) return this.initDisplayLocations
      return this.selectedLocations
    },
    checkboxIndeterminate () {
      // 表示してた初期データを削除
      this.initDisplayLocations = []

      switch (this.selectedLocations.length) {
        case 0:
          return false
        case this.locations.length:
          this.selectedAll = true
          return false
        default:
          return true
      }
    },
    filteredLocations () {
      return this.locations.filter(a => {
        return a.locationName.toLowerCase().includes(this.listSearch.toLowerCase())
      })
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    selectedLocations () {
      if (this.selectedLocations.length === 0) return this.getLocations()
    }
  }
}
</script>

<style>
#customer-list-wrapper {
  height: 100%;
}
@media (max-width: 600px) {
 #customer-list {
   height: 200px;
   overflow-y: scroll;
 }
 #customer-detail{
   height: calc(100% - 200px) ;
   overflow-y: scroll;
 }
}

/* ソートボックスの区切り線 */
#customer-sort-box .flex{
  border-collapse: collapse;
  border-right: 1px solid #CDD2E0;
  border-bottom: 1px solid #CDD2E0;
}

/* 中心の垂直線 */
#customer-list{
  border-right: 4px #D0D5E2 solid !important;
}

/* タブの非アクティブ時の色：灰色 */
#customer-detail .tabs__bar,
#customer-detail .tabs__item:not(.tabs__item--active){
  background-color: #eee !important;
  opacity: 1;
}
/* タブ アクティブ時のスライドバーの色のカスタマイズ */
#customer-detail .tabs__item--active {
  border-top:2px solid #528AD2;
}

/* 各カスタマー情報の縦線 */
.flex .cutomer-info {
  border-left:3px solid #CCC;
}

/* 検索窓のカスタマイズ */
.search .input-group {
  padding:0px;
}
.search  .input-group__input{
  padding: 2px;
  background-color: #DDD;
  border-radius:5px;
}
.search .input-group__details:before {
  background-color: rgba(0,0,0,0)!important;
}

/* リストテーブル 選択時の色 */
.theme--light .table tbody tr[active] {
  background-color: #E9F0F9!important;
}

#customer-list > div {
  display: flex;
  flex-flow: column-reverse;
}
#customer-list > div .table__overflow {
  border-top: 1px solid rgba(0,0,0,.12);
}

</style>



// WEBPACK FOOTER //
// CustomerList.vue?5b44a900